import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { Button } from '@calendly/ui/components/button';
import { DateRangePicker } from '@calendly/ui/components/date-range-picker';
import { ExportIcon } from '@calendly/ui/components/icons';
import { Popup, Header, FooterUI } from '@calendly/ui/components/popup';
import classNames from 'classnames';
import { useState, forwardRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { exportEvents } from 'actions/scheduled_events/export';
import { useGetUserQuery } from 'common';
import FilterListAction from 'components/scheduled_events/filter_list/action';
const BodyTabletUpCSS = "bsngpff";
const exportButtonLabelCss = "ewx864i";
const BodyPhoneCSS = "b1xdtmgy";
const bodyCss = "bvkhcq7";
const Body = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(bodyCss, props.className)} />;
});
const warningContainerTabletUpCss = "w10s1n0a";
const WarningContainerTabletUp = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(warningContainerTabletUpCss, props.className)} />;
});
const warningContainerPhoneCss = "wemnlkj";
const WarningContainerPhone = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(warningContainerPhoneCss, props.className)} />;
});
const presetFilterContainerCss = "p14zbmzr";
const PresetFilterContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(presetFilterContainerCss, props.className)} />;
});
const presetFiltersLabelCss = "p8jhe4r";
const PresetFiltersLabel = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(presetFiltersLabelCss, props.className)} />;
});
const presetFilterCss = "pmittyb";
const PresetFilter = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(presetFilterCss, props.className)} />);
const presetFilters = ['past', 'upcoming', 'this_month', 'this_year'];

// i18n-tasks-use t('publisher.meetings.export_modal.filters.#{presetFilter}')
const getPresetFilterName = presetFilter => I18n.t(`publisher.meetings.export_modal.filters.${presetFilter}`);
const getPresetFilterParams = presetFilter => {
  if (presetFilter === 'this_year') {
    return {
      period: 'fixed',
      start_date: `${new Date().getFullYear()}-01-01`,
      end_date: `${new Date().getFullYear()}-12-31`
    };
  }
  return {
    period: presetFilter
  };
};
export const ExportButton = ({
  scope,
  isPhone,
  text
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentStartDate, setCurrentStartDate] = useState('');
  const [currentEndDate, setCurrentEndDate] = useState('');
  const handleChange = ([start, end]) => {
    setCurrentStartDate(start);
    setCurrentEndDate(end);
  };
  const dispatch = useDispatch();
  const isDisabled = useSelector(state => state.scheduled_events.export.loading);
  const {
    data: {
      timezone
    }
  } = useGetUserQuery();
  const rangeSelected = !!currentStartDate && !!currentEndDate;
  const handleClose = () => {
    setIsOpen(false);
    setCurrentStartDate('');
    setCurrentEndDate('');
  };
  const handleExport = params => {
    dispatch(exportEvents(params, scope));
  };
  const handleSubmit = () => {
    if (!rangeSelected) {
      // If no date range has been selected, export everything
      handleExport({
        period: 'all_time'
      });
    } else {
      handleExport({
        period: 'fixed',
        start_date: currentStartDate,
        end_date: currentEndDate
      });
    }
    handleClose();
  };
  const handlePresetFilterClick = presetFilter => {
    handleExport(getPresetFilterParams(presetFilter));
    handleClose();
  };
  return <>
      <FilterListAction decoration="minimal" isDisabled={isDisabled} onClick={() => setIsOpen(true)}>
        <ExportIcon />
        <span className={exportButtonLabelCss}>
          {text}
        </span>
      </FilterListAction>
      <Popup size="large" isOpen={isOpen} onClose={() => {}}>
        <Header>
          <PresetFilterContainer>
            <PresetFiltersLabel>
              {I18n.t('publisher.meetings.export_modal.select')}
              :
            </PresetFiltersLabel>
            {presetFilters.map(filter => <PresetFilter key={filter} onClick={() => handlePresetFilterClick(filter)}>
                {getPresetFilterName(filter)}
              </PresetFilter>)}
          </PresetFilterContainer>
        </Header>
        <Body className={isPhone ? BodyPhoneCSS : BodyTabletUpCSS}>
          <DateRangePicker startDate={currentStartDate} endDate={currentEndDate} onChange={handleChange} pastSelection timezone={timezone} />
        </Body>
        {isPhone && <WarningContainerPhone>{I18n.t('publisher.meetings.export_modal.external_events_warning')}</WarningContainerPhone>}
        <FooterUI isOffset>
          {!isPhone && <WarningContainerTabletUp>
                <span>{I18n.t('publisher.meetings.export_modal.external_events_warning')}</span>
              </WarningContainerTabletUp>}
          <Button decoration="ghost" onClick={() => handleClose()}>{I18n.t('publisher.meetings.export_modal.cancel_button')}</Button>
          <Button onClick={() => handleSubmit()}>
            {I18n.t('publisher.meetings.export_modal.confirm_button')}
          </Button>
        </FooterUI>
      </Popup>
    </>;
};

require("./export_button.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./export_button.js");